<template>
<div>
	<div class="infomationTable">
		<table class="table">
		    <tr>
			    <th>序号</th>
			    <th>项目名称</th>
			    <th>是否入库（四库一平台）</th>
			    <th>项目规模及技术指标</th>
			    <th>开始时间</th>
			    <th>截止时间</th>
			    <th>获得奖项</th>
			    <th>担任职务</th>
			    <th>所在单位资质等级</th>
			    <th>操作</th>
		    </tr>
		    <tr v-for="(item,index) in formList">
		        <td>
		        	<div class="label">序号</div>
		        	{{index+1}}
		        </td>
		        <td>
		        	<div class="label">项目名称</div>
		        	{{item.name}}
		        </td>
		        <td>
		        	<div class="label">是否入库（四库一平台）</div>
		        	{{item.storeStatus}}
		        </td>
		        <td>
		        	<div class="label">项目规模及技术指标</div>
		        	{{item.quota}}
		        </td>
		        <td>
		        	<div class="label">开始时间</div>
		        	{{item.startTime}}
		        </td>
		        <td>
		        	<div class="label">截止时间</div>
		        	{{item.endTime}}
		        </td>
		        <td>
		        	<div class="label">获得奖项</div>
		        	{{item.awards}}
		        </td>
		        <td>
		        	<div class="label">担任职务</div>
		        	{{item.position}}
		        </td>
		        <td>
		        	<div class="label">所在单位资质等级</div>
		        	{{item.unitLevel}}
		        </td>
		      	<td>
		      		<div class="label">操作</div>
		      		<div class="edit" @click="edit(item.id)">编辑</div>
		      	</td>
		    </tr>
		</table>
	</div>
	
	<!-- 添加按钮 -->
	<div class="addBtn" @click="add"></div>
	
	<!-- 编辑、新增的弹窗 -->
	<div class="infomationAddEdit" v-if="popShow">
		<div class="mask"></div>
		<div class="form">
			<div class="close" @click="cancel"></div>
			<div class="tit f-16 fb">
				<template v-if="addOrEdit==1">
					新增
				</template>
				<template v-if="addOrEdit==2">
					编辑
				</template>	
			</div>
		
			<div class="item cf">
	        	<div class="name fl"><span>*</span>项目名称</div>
	        	<div class="ovh text">
					<input type="text" v-model="popData.name" name="name" placeholder="请填写项目名称">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>是否入库（四库一平台）</div>
	        	<div class="ovh text">
					<input type="text" v-model="popData.storeStatus" name="storeStatus" placeholder="请填写是否入库">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>项目规模及技术指标</div>
	        	<div class="ovh text">
					<input type="text" v-model="popData.quota" name="quota" placeholder="请填写项目规模及技术指标">
				</div>
			</div>

			<div class="item cf">
	        	<div class="name fl"><span>*</span>开始时间</div>
	        	<div class="ovh text">
	        		<el-date-picker
			            v-model="popData.startTime"
			            value-format="yyyy-MM-dd"
			            placeholder="请选择开始时间"
			            :picker-options="startPickerOptions">
			        </el-date-picker>
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>截止时间</div>
	        	<div class="ovh text">
	        		<el-date-picker
			            v-model="popData.endTime"
			            value-format="yyyy-MM-dd"
			            placeholder="请选择截止时间"
			            :picker-options="endPickerOptions">
			        </el-date-picker>
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>获得奖项</div>
	        	<div class="ovh text">
					<input type="text" v-model="popData.awards" name="awards" placeholder="请填写获得奖项">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>担任职务</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.position" name="position" placeholder="请填写担任职务">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>所在单位资质等级</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.unitLevel" name="unitLevel" placeholder="请填写所在单位资质等级">
				</div>
			</div>
			

	      	<div class="btnBox">
				<div class="btn btn1" @click="save">保存</div>
				<div class="btn btn2" @click="cancel">取消</div>
	      	</div>
		</div>
	</div>
</div>
</template>
<script>
import { 
  performanceList,
  performanceAdd,
  performanceEdit,
  performanceDelete,
  performanceQueryById
} from "@/api/tableapi";

export default {
	name: 'tableperformance',
	props:{
		isshow: {
	      	type: Boolean,
  			default: {}
	    }
	},
	watch: {
	    isshow: {
	      immediate: true,
	      handler(newval,oldval) {
	        if (newval) {
	        	this.initData()
	        }
	      }
	    },
	},
	data(){
		return{
		    formList:[],
		    addOrEdit:1,   //1是新增2是编辑
		    popData:{
		    	name:'',
		    	storeStatus:'',
		    	quota:'',
		    	startTime:'',
		    	endTime:'',
		    	awards:'',
		    	position:'',
		    	unitLevel:''
		    },
		    popShow:false,

		    xueliOptions:[]
		}
	},
	computed: {
	    startPickerOptions() {
	      return {
	        disabledDate: time => {
	          return this.popData.endTime ? time.getTime() > new Date(this.popData.endTime).getTime() : false;
	        }
	      };
	    },
	    endPickerOptions() {
	      return {
	        disabledDate: time => {
	          return this.popData.startTime ? time.getTime() < new Date(this.popData.startTime).getTime() : false;
	        }
	      };
	    }
	},
	created(){
		this.initData()
	},
  	methods:{
  		//获取当前表格的数据
  		initData(){
  			let that=this
  			performanceList("").then(res=>{
              if (res.success) {               
                that.formList=res.result.records
              }
            })
        },

        //添加
	    add(){
	    	let that=this
	    	that.addOrEdit=1
	    	that.popData={
		    	name:'',
		    	storeStatus:'',
		    	quota:'',
		    	startTime:'',
		    	endTime:'',
		    	awards:'',
		    	position:'',
		    	unitLevel:''
		    }

		    that.popShow=true
	    },

	    //编辑
	    edit(id){
	    	let that=this
	    	performanceQueryById(id).then(res=>{
		        //console.log(res)
		        if(res.success){
		          that.addOrEdit=2

		          if(res.result.startTime!=''&&res.result.startTime!=null){
		            let startTime=res.result.startTime
		            res.result.startTime=startTime.split(" ")[0]
		          }

		          if(res.result.endTime!=''&&res.result.endTime!=null){
		            let endTime=res.result.endTime
		            res.result.endTime=endTime.split(" ")[0]
		          }

		          that.popData=res.result
		          that.popShow=true
		        }else{
		          that.$message.error(res.message)
		          return false
		        }
		    })
	    },

	    save(){
	    	let that=this

		    //验证，表格结构数据中有必填和校验正则
		    if (that.popData.name==''||that.popData.name==null) {
		    	that.$message.error('请填写项目!');
		    	return false
		    }

		    if (that.popData.storeStatus==''||that.popData.storeStatus==null) {
		    	that.$message.error('请填写是否入库');
		    	return false
		    }

		    if (that.popData.quota==''||that.popData.quota==null) {
		    	that.$message.error('请填写项目规模及技术指标');
		    	return false
		    }

		    if (that.popData.startTime==''||that.popData.startTime==null) {
		    	that.$message.error('请选择开始时间!');
		    	return false
		    }

		    if (that.popData.endTime==''||that.popData.endTime==null) {
		    	that.$message.error('请填写截止名称');
		    	return false
		    }

		    if (that.popData.awards==''||that.popData.awards==null) {
		    	that.$message.error('请填写获得奖项');
		    	return false
		    }

		    if (that.popData.position==''||that.popData.position==null) {
		    	that.$message.error('请填写担任职务!');
		    	return false
		    }

		    if (that.popData.unitLevel==''||that.popData.unitLevel==null) {
		    	that.$message.error('请填写所在单位资质等级');
		    	return false
		    }

		    //通过验证
		    that.popData.startTime+=' 00:00:00'
		    that.popData.endTime+=' 00:00:00'
		    
		    //添加
		    if (that.addOrEdit==1) {
		    	performanceAdd(that.popData).then(res=>{
	              if (res.success) {
	              	that.initData()            
	                that.$message.success('添加成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
		    //编辑
		    if (that.addOrEdit==2) {
		    	performanceEdit(that.popData).then(res=>{
	              if (res.success) { 
	              	that.initData()              
	                that.$message.success('编辑成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
	    },

	    cancel(){
	    	let that=this
	    	that.popShow=false
	    }
  	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/tableperformance/index.vue